import { PropertyStatusForm } from "./PropertyStatusForm";
import { PropertyDeleteSection } from "./PropertyDeleteSection";

interface PropertyStatusTabProps {
  id: string;
  property: any;
  closedData: any;
  isLoading: boolean;
  wasSoldOnLoad?: boolean;
  wasPendingOnLoad?: boolean;
  wasDraftOnLoad?: boolean;
  handleStatusChange: (status: string) => void;
  handleDateChange: (date: Date | undefined) => void;
  handleClosedDateChange: (date: Date | undefined) => void;
  handleClosedDataChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (e: React.FormEvent) => void;
  handleDelete: () => void;
}

export const PropertyStatusTab = ({
  id,
  property,
  closedData,
  isLoading,
  wasSoldOnLoad = false,
  wasPendingOnLoad = false,
  wasDraftOnLoad = false,
  handleStatusChange,
  handleDateChange,
  handleClosedDateChange,
  handleClosedDataChange,
  handleSubmit,
  handleDelete
}: PropertyStatusTabProps) => {
  return (
    <>
      <PropertyStatusForm
        propertyId={id}
        status={property.status}
        contractExpirationDate={property.contractExpirationDate}
        closedData={closedData}
        isLoading={isLoading}
        wasSoldOnLoad={wasSoldOnLoad}
        wasPendingOnLoad={wasPendingOnLoad}
        wasDraftOnLoad={wasDraftOnLoad}
        onStatusChange={handleStatusChange}
        onContractExpirationDateChange={handleDateChange}
        onClosedDateChange={handleClosedDateChange}
        onClosedDataChange={handleClosedDataChange}
        onSubmit={handleSubmit}
      />
      
      <PropertyDeleteSection 
        wasSoldOnLoad={wasSoldOnLoad}
        onDelete={handleDelete} 
      />
    </>
  );
};
